import { PageData } from '../types/content'

export const standardPages: Record<string, PageData> = {
  '/about': {
    eyebrow: {
      nl: 'Over Brugge Retail NV',
      en: 'About Brugge Retail NV',
    },
    title: {
      nl: 'Distributie van food en non-food, gebouwd voor de retail.',
      en: 'Food and non-food distribution, built for retail.',
    },
    description: {
      nl: 'Brugge Retail NV baat de Carrefour-hypermarkt in Brugge uit en is een gespecialiseerde distributeur van food- en non-foodproducten voor supermarkten, retailers, horecabedrijven en instellingen. In de winkel en voor professionele klanten bieden we een breed en betrouwbaar assortiment.',
      en: 'Brugge Retail NV operates the Carrefour hypermarket in Bruges and is a specialist distributor of food and non-food products for supermarkets, retailers, hospitality businesses and institutions. In store and for professional customers, we offer a broad, dependable range.',
    },
    image:
      'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=1600&q=90',
    sections: [
      {
        title: {
          nl: 'Een compleet assortiment',
          en: 'A complete product range',
        },
        body: {
          nl: 'Van verse producten, kruidenierswaren en dranken tot onderhoud, elektro, huishoudlinnen, schoolmateriaal en zakelijke basics: onze afdelingen dekken elke behoefte.',
          en: 'From fresh food, pantry staples and beverages to home care, equipment, home textiles, school supplies and business essentials, our categories cover every need.',
        },
      },
      {
        title: {
          nl: 'Een partner voor retail en professionals',
          en: 'A partner for retail and business',
        },
        body: {
          nl: 'Ons team ondersteunt supermarkten, zelfstandige winkeliers, hotels, restaurants, scholen, kantoren en instellingen met leveringen op maat en op basis van offerte.',
          en: 'Our team supports supermarkets, independent retailers, hotels, restaurants, schools, offices and institutions with quotation-led supply solutions.',
        },
      },
    ],
  },
  '/brands': {
    eyebrow: {
      nl: 'Vertrouwde merken',
      en: 'Trusted brands',
    },
    title: {
      nl: 'De merken die u al kent van thuis.',
      en: 'The names your home already knows.',
    },
    description: {
      nl: 'Ontdek een ruime mix van internationale topmerken en betrouwbare specialisten in al onze afdelingen.',
      en: 'Explore a wide mix of international favourites and dependable specialist brands across every department.',
    },
    image:
      'https://images.unsplash.com/photo-1580915411954-282cb1b0d780?auto=format&fit=crop&w=1600&q=90',
    sections: [
      {
        title: {
          nl: 'Voeding & dranken',
          en: 'Food & refreshment',
        },
        body: {
          nl: 'Nestlé, Nescafé, Coca-Cola, Pepsi, Kellogg’s en veel meer.',
          en: 'Nestlé, Nescafé, Coca-Cola, Pepsi, Kellogg’s and more.',
        },
      },
      {
        title: {
          nl: 'Huis & techniek',
          en: 'Home & technology',
        },
        body: {
          nl: 'Samsung, LG, Sony, Philips, Bosch, Canon en toonaangevende huishoudmerken.',
          en: 'Samsung, LG, Sony, Philips, Bosch, Canon and leading household brands.',
        },
      },
    ],
  },
  '/gallery': {
    eyebrow: {
      nl: 'In onze Carrefour-winkel in Brugge',
      en: 'Inside our Carrefour store in Bruges',
    },
    title: {
      nl: 'Bekijk de winkel voor u langskomt.',
      en: 'See the store before you visit.',
    },
    description: {
      nl: 'Lichte gangen, een royale verse markt en gespecialiseerde afdelingen, ontworpen voor eenvoudig en aangenaam shoppen.',
      en: 'Bright aisles, a generous fresh market and specialist home departments designed for easy, satisfying shopping.',
    },
    image:
      'https://images.unsplash.com/photo-1601598851547-4302969d0614?auto=format&fit=crop&w=1600&q=90',
    sections: [
      {
        title: {
          nl: 'De verse markt',
          en: 'Fresh food hall',
        },
        body: {
          nl: 'Fruit, groenten, bakkerij, vlees en vis in één levendige marktruimte.',
          en: 'Fresh fruit, vegetables, bakery, meat and seafood in one vibrant market space.',
        },
      },
      {
        title: {
          nl: 'Huis & dagelijks leven',
          en: 'Home & lifestyle',
        },
        body: {
          nl: 'Van kookgerei en bedtextiel tot elektro en schoolmateriaal.',
          en: 'From cookware and bedding to electricals and school essentials.',
        },
      },
    ],
  },
  '/news': {
    eyebrow: {
      nl: 'Nieuws & acties',
      en: 'News & promotions',
    },
    title: {
      nl: 'Wat er nieuw is bij Carrefour Brugge.',
      en: 'What’s happening at Carrefour Bruges.',
    },
    description: {
      nl: 'Nieuwe seizoensartikelen, updates uit de afdelingen en informatie voor onze professionele klanten.',
      en: 'New seasonal arrivals, department updates and business information from our store.',
    },
    image:
      'https://images.unsplash.com/photo-1441986300917-64674bd600d8?auto=format&fit=crop&w=1600&q=90',
    sections: [
      {
        title: {
          nl: 'Seizoensnieuwigheden',
          en: 'Seasonal arrivals',
        },
        body: {
          nl: 'Ontdek het hele jaar door nieuwe artikelen voor huis, tuin en school.',
          en: 'Discover new home, garden and school essentials throughout the year.',
        },
      },
      {
        title: {
          nl: 'Zakelijke updates',
          en: 'Business updates',
        },
        body: {
          nl: 'Nieuwe diensten en uitgelichte categorieën voor professionele klanten.',
          en: 'New services and category highlights for professional customers.',
        },
      },
    ],
  },
}
